'use client'
/***
 *
 * @file components/FileUpload/index.tsx
 * @description FileUpload component will be used for rendering the content.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 23 May 2025
 *
 */

import React, { useEffect, useState } from "react";
// import "./FileUpload.scss";
import ImageWrapper from "../ImageWrapper";

type Props = {
  accept?: string;
  capture?: "user" | "environment" | "none"
}

const FileUpload = ({ accept = '', capture = "none" }: Props) => {

  const [fileUrl, setFileUrl] = useState('');
  useEffect(()=>{
    setFileUrl("");
  },[]);
  
  return (
    <div className="FileUpload-container" data-testid="FileUpload">
      <ImageWrapper src={fileUrl} />
      <input type="file"
      {...(() => {
        if (accept !== "") {
          return { accept }
        }
        else {
          return {}
        }
      })()}
      {...(() => {
        if (capture !== "none") {
          return { capture }
        }
        else {
          return {}
        }
      })()} onChange={(e) => {
        e?.target?.files?.[0] && setFileUrl(URL?.createObjectURL(e?.target?.files[0]))
      }}
      />
    </div>
  );
};

export default FileUpload;
